<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <div class="px-3" v-bind="$attrs">
      
      <v-card v-if="single" class="mb-4" outlined>
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="d-flex row align-center px-4">
            <v-icon class="me-2">mdi-{{ $attrs.icon }}</v-icon>
            <span class="d-flex row align-center justify-start text-h6">
              {{ $attrs.title }}
              <help-info
                :element-name="`${serviceName}-${componentName}-single-${$attrs.name || 'default'}`"
                :help-data="helpData"
                :label="$attrs.title"
                :service-name="serviceName"
                class="ms-1"
              />
            </span>
          </div>
        </v-card-title>
        <v-card-text class="list-content pt-2">
          <p v-if="$attrs.subtitle" class="text-right">
            {{ $attrs.subtitle }}
          </p>
          <slot name="content"></slot>
        </v-card-text>
      </v-card>

      <template v-else>
        <v-card
          v-for="(item, index) in components"
          :key="index"
          class="mb-6"
          elevation="2"
        >
          <v-card-title class="d-flex justify-start align-center pb-2 bg-lighten-4">
            <v-icon color="primary" class="me-2">mdi-{{ item.icon }}</v-icon>
            <span class="text-h6">{{ item.title }}</span>
            <help-info
              :element-name="`${serviceName}-${componentName}-${item.name}-${item.title}`"
              :help-data="helpData"
              :label="item.title"
              :service-name="serviceName"
              class="ms-2"
            />
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="list-content pt-4">
            <template
              v-if="
                (item.name === 'textCards' &&
                  ($route.name === 'qr.bShop' ||
                    $route.name === 'qr.editCPage' ||
                    $route.name === 'qr.cPage' ||
                    $route.name === 'qr.name.editBShop' ||
                    $route.name === 'qr.name.id.editBShop' ||
                    $route.name === 'modelsList.edit' ||
                    $route.name === 'qr.name.editBpage' ||
                    $route.name === 'qr.name.id.editBpage' ||
                    $route.name === 'modelsList.menu.edit' ||
                    $route.name === 'qr.menu' ||
                    $route.name === 'qr.card' ||
                    $route.name === 'qr.name.editMenu' ||
                    $route.name === 'qr.name.id.editMenu')) ||
                item.name === 'Service' ||
                item.name === 'Floor' ||
                (item.name === 'socialMediaIcons' &&
                  [
                    'qr.socialMedia',
                    'qr.name.editSocial',
                    'qr.name.id.editSocial',
                    'qr.create.editSocialModel',
                    'qr.create.SocialMediaModel',
                  ].includes($route.name)) ||
                (item.name === 'PicSelector' &&
                  ![
                      'qr.name.editPhoto',
                      'qr.name.id.editPhoto',
                      'qr.photo',
                      'qr.gift',
                      'modelsList.memories.edit',
                      'qr.create.memories',
                      'qr.name.editgift',
                      'qr.name.id.editgift',
                      'qr.create.photoGalleryModel',
                      'qr.create.photoGalleryedit',
                  ].includes($route.name)) ||
                item.name === 'Faq' ||
                (item.name === 'pdfSelector' &&
                  ![
                    'qr.pdf',
                    'qr.name.id.editPdf',
                    'qr.name.editPdf',
                    'qr.create.pdfGalleryedit',
                    'qr.create.pdfGalleryModel',

                  ].includes($route.name)) ||
                item.name === 'Blog' ||
                (item.name === 'VideoGallery' &&
                  ![
                      'qr.video',
                      'qr.name.id.editVideo',
                      'qr.name.editVideo',
                      'qr.cardVisit',
                      'qr.cardVisitPro',
                      'qr.create.cardVisitProModel',
                      'qr.name.edit',
                      'qr.name.edit.pro',
                      'qr.name.id.edit.pro',
                      'qr.name.id.edit',
                      'qr.gift',
                      'qr.name.editgift',
                      'qr.name.id.editgift',
                      'modelsList.memories.edit',
                      'qr.create.memories'
                  ].includes($route.name)) ||
                (item.name === 'FeedBack' &&
                  $route.name !== 'qr.product.productPro' && $route.name !== 'qr.create.productPro' ) ||
                (item.name === 'consultationNew' &&
                  $route.name !== 'qr.product.productPro' && $route.name !== 'qr.create.productPro') ||
                item.name === 'CounterService' ||
                item.name === 'Product' ||
                item.name === 'Appointments' ||
                item.name === 'singleProductEditor' ||
                item.name === 'ServiceSection' ||
                item.name === 'consultation' ||
                item.name === 'specialCategoryManager' ||
                (item.name === 'baseInfo' &&
                  [
                    'qr.socialMedia',
                    'qr.catalog',
                    'qr.name.editCatalog',
                    'qr.name.id.editCatalog',
                    'qr.name.editSocial',
                    'qr.name.id.editSocial',
                    'qr.create.editSocialModel',
                    'qr.create.SocialMediaModel',

                  ].includes($route.name))
              "
            >
              <custom-tabs v-model="tabs" grow>
                <template v-slot:staticTabs>
                  <v-tab :ripple="false">
                    <div
                      class="d-flex row gap-0 align-center align-self-center align-items-center px-2"
                      style="
                        justify-content: center !important;
                        align-items: center;
                      "
                    >
                      <div class="cornel-left"></div>
                      <div class="cornel-right"></div>
                      <v-icon
                        class="me-2"
                        style="justify-content: center !important"
                        >mdi-plus
                      </v-icon>
                      {{ $t("add") }}
                      <help-info
                        :element-name="`${serviceName}-${componentName}-${
                          item.name || $route.name
                        }-${tabItems[0].value}`"
                        :help-data="helpData"
                        :label="`${tabItems[0].text}`"
                        :service-name="serviceName"
                        class="buttoninfo"
                      />
                    </div>
                  </v-tab>

                  <v-tab
                    v-if="
                      item.name !== 'singleProductEditor' &&
                      !(
                        [
                            'qr.cardVisit',
                            'qr.name.edit',
                            'qr.name.id.edit',
                            'qr.cardVisitPro',
                            'qr.name.edit.pro',
                            'qr.name.id.edit.pro',
                            'qr.gift',
                            'qr.name.id.editgift',
                            'qr.name.editgift',
                            'modelsList.memories.edit',
                            'qr.create.memories'
                          
                        ].includes($route.name) &&
                        (item.name === 'VideoGallery' ||
                          item.name === 'imageUploader')
                      ) &&
                      !(
                        [
                          'qr.pdf',
                          'qr.name.editPdf',
                          'qr.name.id.editPdf',
                          'qr.create.pdfGalleryedit',
                          'qr.create.pdfGalleryModel',

                        ].includes($route.name) && item.name === 'pdfSelector'
                      )
                    "
                    :ripple="false"
                  >
                    <div
                      class="d-flex row gap-0 align-center align-self-center align-items-center px-2"
                      style="
                        justify-content: center !important;
                        align-items: center;
                      "
                    >
                      <div class="cornel-left"></div>
                      <div class="cornel-right"></div>
                      <v-icon
                        class="me-2"
                        style="justify-content: center !important"
                        >mdi-cogs
                      </v-icon>
                      {{ $t("header_color_text_settings") }}
                      <help-info
                        :element-name="`${serviceName}-${componentName}-${
                          item.name || $route.name
                        }-${tabItems[1].value}`"
                        :help-data="helpData"
                        :label="`${tabItems[1].text}`"
                        :service-name="serviceName"
                        class="buttoninfo"
                      />
                    </div>
                  </v-tab>

                  <v-tab
                    v-show="
                      value &&
                      !!value[item.model] &&
                      !!value[item.model].design
                    "
                    :ripple="false"
                  >
                    <div
                      class="d-flex row gap-0 align-center align-self-center align-items-center"
                    >
                      <div class="cornel-left"></div>
                      <div class="cornel-right"></div>
                      <v-icon class="me-2">mdi-image</v-icon>
                      {{ $t("select_image") }}
                      <help-info
                        :element-name="`${serviceName}-${componentName}-${
                          item.name || $route.name
                        }-${tabItems[2].value}`"
                        :help-data="helpData"
                        :label="`${tabItems[2].text}`"
                        :service-name="serviceName"
                        class="buttoninfo"
                      />
                    </div>
                  </v-tab>

                  <template v-if="!!item.tabs && !!item.tabs.length">
                    <v-tab
                      v-for="(tab, j) in item.tabs"
                      :key="j"
                      :ripple="false"
                    >
                      <div
                        class="d-flex row gap-0 align-center align-self-center align-items-center"
                      >
                        <div class="cornel-left"></div>
                        <div class="cornel-right"></div>
                        <v-icon class="me-2">{{ tab.icon }}</v-icon>
                        {{ tab.title }}
                        <help-info
                          :element-name="`${serviceName}-${componentName}-${
                            item.name || $route.name
                          }-${tab.value || tab.text}`"
                          :help-data="helpData"
                          :label="`${tab.text}`"
                          :service-name="serviceName"
                          class="buttoninfo"
                        />
                      </div>
                    </v-tab>
                  </template>
                </template>

                <template v-slot:middle>
                  <div class="py-2"></div>
                </template>

                <template v-slot:staticItems>
                  <v-tab-item>
                    <p v-if="item.subtitle" class="text-right">
                      {{ item.subtitle }}
                    </p>
                    <component
                      :is="item.name"
                      v-if="!!value && !!item.model"
                      v-model="value[item.model]"
                      :main-data="data"
                    />

                    <component
                      :is="item.name"
                      v-else
                      :data="data"
                      :main-data="data"
                      :single="item.title === $t('upload_catalog_images')"
                    />
                  </v-tab-item>

                  <v-tab-item>
                    <floor-setting
                      v-if="item.name === 'Floor'"
                      v-model="value.Floor"
                    >
                    </floor-setting>

                    <galleries-texts
                      v-else
                      v-model="
                        value[!!value[item.name] ? item.name : item.model]
                      "
                      :be-grid="$route.name === 'qr.photo'|| $route.name === 'qr.create.photoGalleryModel'"
                      :both="
                        item.name === 'PicSelector' ||
                        item.name === 'pdfSelector' ||
                        item.name === 'Blog'
                      "
                      :just-color="
                        item.name === 'textCards' ||
                        (item.name === 'baseInfo' &&
                          [
                            'qr.socialMedia',
                            'qr.catalog',
                            'qr.name.editCatalog',
                            'qr.name.id.editCatalog',
                            'qr.name.editSocial',
                            'qr.name.id.editSocial',
                            'qr.create.editSocialModel',
                            'qr.create.SocialMediaModel',

                          ].includes($route.name)) ||
                        (item.name === 'socialMediaIcons' &&
                          [
                            'qr.socialMedia',
                            'qr.name.editSocial',
                            'qr.name.id.editSocial',
                            'qr.create.editSocialModel',
                            'qr.create.SocialMediaModel',

                          ].includes($route.name))
                      "
                      :second-position="
                        [
                            'qr.video',
                            'qr.name.editVideo',
                            'qr.name.id.editVideo',
                            'qr.gift',
                            'qr.name.id.editgift',
                            'qr.name.editgift',
                            'modelsList.memories.edit',
                            'qr.create.memories'
                        ].includes($route.name)
                      "
                      :show="!item?.settings?.notColor"
                    />
                  </v-tab-item>

                  <v-tab-item
                    v-if="item.name !== 'singleProductEditor'"
                    v-show="
                      value && value[item.model] && value[item.model].design
                    "
                  >
                    <design-sections
                      v-if="
                        !!value &&
                        !!value[item.model] &&
                        !!value[item.model].design
                      "
                      v-model="value[item.model].design"
                    />
                  </v-tab-item>

                  <template v-if="!!item.tabs && !!item.tabs.length">
                    <v-tab-item v-for="(tab, j) in item.tabs" :key="j">
                      <component
                        :is="tab.component"
                        v-model="value[item.model][tab.model]"
                        :main-data="data"
                      />
                    </v-tab-item>
                  </template>
                </template>
              </custom-tabs>
            </template>

            <template v-else>
              <custom-tabs v-if="!!item.tabs" v-model="tabs" grow>
                <template v-slot:staticTabs>
                  <template v-if="!!item.tabs && !!item.tabs.length">
                    <v-tab
                      v-for="(tab, j) in item.tabs"
                      :key="j"
                      :ripple="false"
                    >
                      <div
                        class="d-flex row gap-0 align-center align-self-center align-items-center"
                      >
                        <div class="cornel-left" />
                        <div class="cornel-right" />
                        <v-icon class="me-2">{{ tab.icon }}</v-icon>
                        {{ tab.title }}
                        <help-info
                          :element-name="`${serviceName}-${componentName}-${
                            item.name || $route.name
                          }-${tab.value}`"
                          :help-data="helpData"
                          :label="`${tab.title}`"
                          :service-name="serviceName"
                          class="buttoninfo"
                        />
                      </div>
                    </v-tab>
                  </template>
                </template>

                <template v-slot:middle>
                  <div class="py-2" />
                </template>

                <template v-slot:staticItems>
                  <v-tab-item v-for="tab in item.tabs" :key="tab.name">
                    <component
                      :is="tab.component"
                      v-model="value[item.model][tab.model]"
                      :main-data="data"
                    />
                  </v-tab-item>
                </template>
              </custom-tabs>

              <template v-else>
                <p v-if="item.subtitle" class="text-right">
                  {{ item.subtitle }}
                </p>

                <component
                  :is="item.name"
                  v-if="value && item.model"
                  v-model="value[item.model]"
                  :main-data="data"
                  @change="calledChange"
                />

                <component
                  :is="item.name"
                  v-else
                  :data="data"
                  :main-data="data"
                  @change="calledChange"
                />
              </template>
            </template>
          </v-card-text>
        </v-card>
      </template>

    </div>
  </help-info-wrapper>
</template>

<script>
import ThemeSelector2 from "../../pages/otherQrTypes/menu/cm/ThemeSelector2.vue";
import choseApplications from "../../pages/otherQrTypes/applicaion/components/choseApplications.vue";
import HelpInfoWrapper from "../../pages/qrland/components/helpAcordion/HelpInfoWrapper.vue";
import imageUploader2 from "../../pages/goldLabel/components/imageUploader2.vue";
import voiceGallery from "../../components/UploadCenter/voiceGallery/index.vue";
import voiceGalleryAcc from "../../components/UploadCenter/voiceGallery/template/voiceGalleryAcc.vue";
import HelpInfo from "../../pages/qrland/components/helpAcordion/HelpInfo.vue";
import baseInfoVoice from "../../pages/Voice/components/baseInfoVoice.vue";
import consultationNew from "../../components/consultationNew/consultationNew.vue";
import myassets from "../../components/Assets/index.vue";
import FloorSetting from "../../components/Template/FloorSetting.vue";
import baseInfoFeedback from "../../pages/otherQrTypes/feedBack/components/baseInfoFeedback.vue";
import GeneralSettings from "../../pages/otherQrTypes/menu/cm/GeneralSettings.vue";
import baleActions from "../../pages/otherQrTypes/bale/component/baleActions.vue";
import baleBaseInfo from "../../pages/otherQrTypes/bale/component/baleBaseInfo.vue";
import eitaaActions from "../../pages/otherQrTypes/eitaa/component/eitaaActions.vue";
import eitaaBaseInfo from "../../pages/otherQrTypes/eitaa/component/eitaaBaseInfo.vue";
import robikaActions from "../../pages/otherQrTypes/robika/component/robikaActions.vue";
import robikaBaseInfo from "../../pages/otherQrTypes/robika/component/robikaBaseInfo.vue";
import priceLabelInfo from "../../pages/priceLabel/components/priceLabelInfo.vue";

const ArmsChooser = () => import("@/view/components/Product/armsChooser");
const factoryGoldLabel = () =>
  import("../../pages/goldLabel/components/factoryGoldLabel.vue");
const palletCommercial = () =>
  import("../../pages/commercial/components/cm/palletCommercial.vue");
const DesignSections = () =>
  import("../../pages/businessPage/components/cm/designSections");
const GalleriesTexts = () =>
  import("@/view/pages/businessPage/components/view/galleriesTexts");
const PicSelector = () => import("@/view/components/UploadCenter/picSelector");
const pdfSelector = () => import("@/view/components/Gallery/PdfGallery");
const bannerSelector = () =>
  import("@/view/components/UploadCenter/bannerSelector");
const logoSelect = () =>
  import("../../pages/commercial/components/view/bLogoSelect.vue");
const Faq = () => import("@/view/components/Faq");
const Blog = () => import("@/view/components/Blog");
const colorPallete = () => import("../../pages/qrland/components/colorPallete");
const Service = () => import("@/view/components/Service");
const qrCustomize = () => import("../../pages/qrland/components/qrCustomize");
const socialMediaIcons = () =>
  import("../../pages/qrland/components/socialMediaIcons");
const imageUploader = () =>
  import("../../pages/qrland/components/imageUploader");
const VideoGallery = () => import("@/view/components/Gallery/VideoGallery");
const VideoGallerySingle = () =>
  import("@/view/components/Gallery/VideoGallerySingle");
const textCards = () => import("../../pages/qrland/components/textCards");
const managmentLanguage = () =>
  import("../../pages/qrland/components/managmentLanguage");
const addLanguage = () => import("../../pages/qrland/components/addLanguage");
const textCardDiscount = () =>
  import("../../pages/qrland/components/textCardDiscount");
const manageHourLimitQr = () =>
  import("../../pages/qrland/components/qrManage/manageHourLimitQr");
const managePasswordQr = () =>
  import("../../pages/qrland/components/qrManage/managePasswordQr");
const manageClickLimitQr = () =>
  import("../../pages/qrland/components/qrManage/manageClickLimitQr");
const manageRedirectQr = () =>
  import("../../pages/qrland/components/qrManage/manageRedirectQr");
const FeedBack = () => import("@/view/components/Comment/FeedBack");
const Consultation = () => import("@/view/components/Consultation");
const Counter = () => import("@/view/components/Counter");
const Product = () => import("@/view/components/Product/index");
const WorkSheet = () => import("@/view/components/WorkSheet");
const Personnel = () => import("@/view/components/Personnel");
const Customer = () => import("@/view/components/Customer");
const CounterService = () => import("@/view/components/CounterService");
const ServiceSection = () => import("@/view/components/ServiceSection");
const BaseInfo = () => import("@/view/components/otherBase/baseInfo");
const themeSelector = () =>
  import("../../pages/qrland/components/themes/themeSelector");
const Features = () => import("@/view/pages/product/features");
const singleProductEditor = () =>
  import("@/view/components/Product/singleProductEditor");
const factoryInfo = () => import("@/view/pages/product/factoryInfo");
const manageGateways = () =>
  import(
    "@/view/pages/qrland/components/qrManage/manageShop/manageGateways.vue"
  );
const factoryLabel = () =>
  import("@/view/pages/productLabel/components/factoryLabel.vue");
const manageTableReservation = () =>
  import(
    "@/view/pages/qrland/components/qrManage/manageShop/manageTableReservation.vue"
  );
const manageCart = () =>
  import("@/view/pages/qrland/components/qrManage/manageShop/manageCart.vue");
const Appointments = () =>
  import("@/view/pages/otherQrTypes/appointment/cm/Appointments.vue");
const appointmentReserveManager = () =>
  import(
    "@/view/pages/otherQrTypes/appointment/cm/appointmentReserveManager.vue"
  );
const orderNotices = () =>
  import(
    "@/view/pages/qrland/components/qrManage/manageShop/manageOrderNotices.vue"
  );
const manageDiscounts = () =>
  import(
    "@/view/pages/qrland/components/qrManage/manageShop/manageDiscounts.vue"
  );
const specialCategoryManager = () =>
  import("@/view/components/Category/specialCategoryManager.vue");
const CallToAction = () => import("@/view/components/CallToAction.vue");
const shopLogo = () =>
  import("@/view/pages/businessPage/components/cm/shopLogo.vue");
const shopLogo_menu = () =>
  import("@/view/pages/businessPage/components/cm/shopLogo_menu.vue");
const shopLoginConfig = () =>
  import("@/view/pages/businessPage/components/cm/shopLoginConfig.vue");
const InsuranceManage = () =>
  import("@/view/components/Insurance/InsuranceManage.vue");
const previewerQr = () =>
  import("@/view/pages/qrland/components/previewerQr.vue");
const customerClubSettings = () =>
  import("@/view/components/fragments/customerClubSettings.vue");
const advanceSettings = () =>
  import("@/view/components/fragments/advanceSettings.vue");
const Floor = () => import("@/view/components/Template/Floor.vue");
const chosethem = () =>
  import("@/view/pages/commercial/components/cm/choseThem.vue");
const manageAdvertising = () =>
  import(
    "@/view/pages/qrland/components/qrManage/manageShop/manageAdvertising.vue"
  );
const luckWheelInfo = () =>
  import("@/view/pages/otherQrTypes/luckWheel/cm/luckWheelInfo.vue");
const luckWheelManagement = () =>
  import("@/view/pages/otherQrTypes/luckWheel/cm/luckWheelManagement.vue");
const luckWheelLogin = () =>
  import("@/view/pages/otherQrTypes/luckWheel/cm/luckWheelLogin.vue");
const AddAccount = () =>
  import("@/view/pages/multiCart/component/AddAccount.vue");
const CustomerMultiCart = () =>
  import("@/view/pages/multiCart/component/Customer.vue");
const ManagementAccount = () =>
  import(
    "@/view/pages/multiCart/component/ManagementAccount/ManagementAccount.vue"
  );
const ManagementAdvanced = () =>
  import("@/view/pages/multiCart/component/ManagementAdvanced.vue");
const ManagementColor = () =>
  import("@/view/pages/multiCart/component/ManagementColor.vue");
const Notified = () => import("@/view/pages/multiCart/component/Notified.vue");
const Register = () => import("@/view/pages/multiCart/component/Register.vue");
const SettingAdvanced = () =>
  import("@/view/pages/multiCart/component/SettingAdvanced.vue");
const ManagementAccountBank = () =>
  import(
    "@/view/pages/BankCart/component/ManagementAccount/ManagementAccount.vue"
  );

export default {
  name: "ListContentEditor",
  props: {
    value: Object,
    components: [Array, Object],
    data: [Array, String, Object],
    single: Boolean,
  },

  components: {
    HelpInfoWrapper,
    HelpInfo,
    ArmsChooser,
    CallToAction,
    DesignSections,
    GalleriesTexts,
    colorPallete,
    BaseInfo,
    textCards,
    textCardDiscount,
    imageUploader,
    socialMediaIcons,
    qrCustomize,
    Faq,
    pdfSelector,
    VideoGallery,
    PicSelector,
    manageHourLimitQr,
    managePasswordQr,
    manageClickLimitQr,
    manageRedirectQr,
    bannerSelector,
    FeedBack,
    Blog,
    Service,
    VideoGallerySingle,
    Consultation,
    Counter,
    Product,
    WorkSheet,
    Personnel,
    Customer,
    CounterService,
    ServiceSection,
    themeSelector,
    Features,
    singleProductEditor,
    factoryInfo,
    manageGateways,
    manageTableReservation,
    manageCart,
    Appointments,
    appointmentReserveManager,
    orderNotices,
    specialCategoryManager,
    manageDiscounts,
    shopLogo,
    shopLoginConfig,
    InsuranceManage,
    customerClubSettings,
    advanceSettings,
    Floor,
    chosethem,
    manageAdvertising,
    factoryLabel,
    factoryGoldLabel,
    logoSelect,
    palletCommercial,
    voiceGallery,
    myassets,
    FloorSetting,
    consultationNew,
    imageUploader2,
    voiceGalleryAcc,
    baseInfoVoice,
    baseInfoFeedback,
    choseApplications,
    managmentLanguage,
    addLanguage,
    luckWheelInfo,
    luckWheelManagement,
    luckWheelLogin,
    AddAccount,
    CustomerMultiCart,
    ManagementAccount,
    ManagementAdvanced,
    ManagementColor,
    Notified,
    Register,
    SettingAdvanced,
    previewerQr,
    GeneralSettings,
    ThemeSelector2,
    shopLogo_menu,
    baleActions,
    baleBaseInfo,
    eitaaActions,
    eitaaBaseInfo,
    robikaActions,
    robikaBaseInfo,
    priceLabelInfo,
    ManagementAccountBank

  },

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "list-expansion-content",
    tabs: null,
    tabItems: [], 
  }),
  created() {
    this.$root.$on("openCategoryPanel", this.openCategoryPanel);
    this.tabItems = [
      { value: "added", text: this.$t("add"), id: 1 },
      { value: "setting-color", text: this.$t("header_color_settings"), id: 2 },
      { value: "choice-image", text: this.$t("select_image"), id: 3 },
    ];
  },
    beforeDestroy() {
    this.$root.$off("openCategoryPanel", this.openCategoryPanel);
  },

  methods: {
    calledChange(e) {
      console.log("change is called: ", e);
    },
    openCategoryPanel() {
      this.panel = this.components.findIndex((item) => item.name === "Product");
    },

  },
};
</script>

<style scoped>

.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

@media screen and (max-width: 600px) {
  .list-content {
    padding: 0 4px !important;
  }
}
</style>
